import type { FlatRow, TimelineRow } from './types'

export function flattenRows (rows: TimelineRow[], openKeys: Set<string>): FlatRow[] {
  const result: FlatRow[] = []
  const walk = (nodes: TimelineRow[]) => {
    for (const node of nodes) {
      const hasChildren = !!(node.children && node.children.length)
      const open = hasChildren && openKeys.has(node.key)
      result.push({ key: node.key, label: node.label, level: node.level, hasChildren, open, row: node })
      if (open) {
        walk(node.children as TimelineRow[])
      }
    }
  }
  walk(rows || [])
  return result
}

export function collectInitiallyOpen (rows: TimelineRow[]): string[] {
  const keys: string[] = []
  const walk = (nodes: TimelineRow[]) => {
    for (const node of nodes) {
      if (node.open && node.children && node.children.length) {
        keys.push(node.key)
      }
      if (node.children) {
        walk(node.children)
      }
    }
  }
  walk(rows || [])
  return keys
}

export function findRootRow (rows: TimelineRow[], key: string): TimelineRow | null {
  const contains = (node: TimelineRow): boolean => {
    if (!node.children) {
      return false
    }
    return node.children.some(child => child.key === key || contains(child))
  }
  for (const root of rows || []) {
    if (contains(root)) {
      return root
    }
  }
  return null
}
